// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arrow,
.arrow::before {
  position: absolute;
  width: 8px;
  height: 8px;
  z-index: -1;
}

.arrow::before {
  content: "";
  transform: rotate(45deg);
  background: #333;
}

label + .tooltip2 {
  visibility: hidden;
}

label:hover + .tooltip2 {
  visibility: visible !important;
}

.tooltip2:hover {
  visibility: visible !important;
}

.tooltip2 {
  background: #333;
  color: #ffffff;
  padding: 12px 16px;
  opacity: 1;
  border-radius: 6px;
  z-index: 1;
  font-size: 14px;
}
.tooltip2 p {
  font-size: 14px;
}

.tooltip2[data-popper-placement^=top] > .arrow {
  bottom: -4px;
}

.tooltip2[data-popper-placement^=bottom] > .arrow {
  top: -4px;
}

.tooltip2[data-popper-placement^=left] > .arrow {
  right: -4px;
}

.tooltip2[data-popper-placement^=right] > .arrow {
  left: -4px;
}`, "",{"version":3,"sources":["webpack://./resources/js/React/Components/Form/style.scss"],"names":[],"mappings":"AAAA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,wBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AACF;AACE;EACE,eAAA;AACJ;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,SAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,UAAA;AAAF","sourcesContent":[".arrow,\n.arrow::before {\n  position: absolute;\n  width: 8px;\n  height: 8px;\n  z-index: -1;\n}\n\n.arrow::before {\n  content: '';\n  transform: rotate(45deg);\n  background: #333;\n}\n\nlabel + .tooltip2 {\n  visibility: hidden;\n}\n\nlabel:hover + .tooltip2 {\n  visibility: visible !important;\n}\n\n.tooltip2:hover {\n  visibility: visible !important;\n}\n\n.tooltip2 {\n  background: #333;\n  color: #ffffff;\n  padding: 12px 16px;\n  opacity: 1;\n  border-radius: 6px;\n  z-index: 1;\n  font-size: 14px;\n\n  p {\n    font-size: 14px;\n  }\n}\n\n.tooltip2[data-popper-placement^='top'] > .arrow {\n  bottom: -4px;\n}\n\n.tooltip2[data-popper-placement^='bottom'] > .arrow {\n  top: -4px;\n}\n\n.tooltip2[data-popper-placement^='left'] > .arrow {\n  right: -4px;\n}\n\n.tooltip2[data-popper-placement^='right'] > .arrow {\n  left: -4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
